import { render, staticRenderFns } from "./smoothPktContent.vue?vue&type=template&id=0084f31f"
import script from "./smoothPktContent.vue?vue&type=script&lang=js"
export * from "./smoothPktContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports